import {Component, OnInit} from '@angular/core';
import {NewPageService} from '../../templates/new-page/service/new-page.service';
import {NewPageList} from '../../core/models/new-page-list';

import {ConfirmationService} from 'primeng/components/common/confirmationservice';
import {Constants} from '../../core/config/Constants';

@Component({
  selector: 'app-text-box',
  templateUrl: './text-box.component.html',
  styleUrls: ['./text-box.component.css'],
  providers: [NewPageService]
})
export class TextBoxComponent implements OnInit {

  constructor(private newPageService:NewPageService, private confirmationService: ConfirmationService) {
    this.newPageService.validate$.subscribe(validate => {
      if (validate) {
        this.validate();
      }
    });
  }

  aboutUs: NewPageList;
  textSizes = [14, 16, 18, 20, 22, 24, 26, 28, 30, 32];
  textStyles = [
    Constants.ABOUT_TYPE_TEXT_PREF_STYLE_NORMAL,
    Constants.ABOUT_TYPE_TEXT_PREF_STYLE_BOLD,
    Constants.ABOUT_TYPE_TEXT_PREF_STYLE_ITALIC,
    Constants.ABOUT_TYPE_TEXT_PREF_STYLE_BOLDITALIC
  ];

  textClass = '';

  ngOnInit() {
    if (this.aboutUs.aboutPrefs.textsize === undefined || this.aboutUs.aboutPrefs.textstyle === undefined) {
      this.aboutUs.aboutPrefs.textsize = 14;
      this.aboutUs.aboutPrefs.textstyle = 'normal';
    }
  }

  eventText: boolean = true;

  _ref: any;

  confirmDelete() {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to delete ?',
      accept: () => {
        this.remove();
      }
    });
  }

  remove() {
    this.newPageService.removeItem(this.aboutUs);
    console.log('remove');
    this._ref.destroy();
  }

  upItem() {
    this.newPageService.upItem(this.aboutUs);
  }

  downItem() {
    this.newPageService.downItem(this.aboutUs);
  }

  validate() {
    if (this.aboutUs.text == null || this.aboutUs.text.trim().length < 1) {
      this.textClass = 'fieldWithErrors';
    } else {
      this.textClass = '';
    }
  }

  textSizeOnChange(size) {
    this.aboutUs.aboutPrefs.textsize = parseInt(size);
  }
}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/layout/text-box/text-box.component.ts